import HtmlView from '_core/components/HtmlView';

export default HtmlView;
